import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export type NotificationFile = {
  id: string;
  originalName: string;
  status: string;
  boardId: string | null;
};

export type Notification = {
  id: string;
  type: string;
  message: string;
  unread: boolean;
  createdAt: string;
  file?: NotificationFile;
};

@Injectable({
  providedIn: 'root',
})
export class NotificationsApiService {
  private readonly baseUrl = `${environment.apiUrl}/api`;

  constructor(private http: HttpClient) {}

  /**
   * Get all unread notifications for a project
   */
  getUnreadNotifications(projectId: string): Observable<Notification[]> {
    return this.http.get<Notification[]>(`${this.baseUrl}/${projectId}/notifications/unread`);
  }

  /**
   * Mark a notification as read
   */
  markAsRead(projectId: string, notificationId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${projectId}/notifications/${notificationId}/read`, {});
  }
}

